import React from 'react';
import { Row, Col, Tabs } from 'antd';
import { Route } from 'react-router-dom';
import Widget from 'components/Widget';
import Listing from '../listing';
import listingCrisis from '../listingCrisis';

const { TabPane } = Tabs;

const getTabs = (match) => [
  {
    name: 'BRAND',
    key: 'list-quota',
    route: <Route path={`${match.path}/list-quota`} component={Listing}/>,
  },
  {
    name: 'CAMPAIGN',
    key: 'list-quota-campaign',
    route: <Route path={`${match.path}/list-quota-campaign`} component={Listing}/>,
  },
  {
    name: 'CRISIS',
    key: 'list-quota-crisis',
    route: <Route path={`${match.path}/list-quota-crisis`} component={listingCrisis}/>,
  },
];

const getDefaultActiveKey = () => {
  const { pathname } = window.location;
  if (pathname.includes('list-quota-campaign')) {
    return 'list-quota-campaign';
  } else if (pathname.includes('list-quota-crisis')) {
    return 'list-quota-crisis';
  } else {
    return 'list-quota';
  }
};

const Search = (props) => {
  const { match, history } = props;
  
  const handleChangeTab = (key) => {
    history.push(`${match.path}/${key}`);
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
          >
              <Tabs onChange={handleChangeTab} defaultActiveKey={getDefaultActiveKey()} type="card">
                {
                  getTabs(match).map(tab =>
                    <TabPane tab={tab.name} key={tab.key}>
                      {tab.route}
                    </TabPane>
                  )
                }
              </Tabs>
          </Widget>
        </Col>
      </Row>
    </>
  );
}

export default Search;
